module.exports = __webpack_public_path__ + "img/twitter_white.0b7a6888.svg";